import type { FaireBrandEntity } from "../../entity_types/brand";

export const potluck: FaireBrandEntity = {
  token: "potluck",
  type: "brand",
  name: "Potluck",
  logoUrl: "/images/products/Snacks/potluck-logo.webp",
  description: "Premium Korean-inspired condiments and sauces",
  rating: 4.9,
  location: "Los Angeles, CA",
  minimumOrderDollars: 150,
  tags: ["korean", "condiments", "premium", "artisanal"],
  isInsider: true,
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
